import { companyUserSchema } from "@/schema/CompanyUser";
import { z } from "zod";

export const companyUserCreateSchema = companyUserSchema
  .omit({ id: true })
  .extend({
    password: z.string().min(8),
  });

export const companyUserEditSchema = companyUserSchema.omit({ id: true });
export const companyUserProfileEditSchema = companyUserSchema.omit({
  id: true,
  role: true,
});

export const changePasswordSchema = z.object({
  old_password: z.string().min(8),
  new_password: z.string().min(8),
});

export const companyMemberResetPasswordSchema = z.object({
  password: z.string().min(8),
});

export type CompanyUserCreate = z.infer<typeof companyUserCreateSchema>;
export type CompanyUserEdit = z.infer<typeof companyUserEditSchema>;
export type CompanyUserProfileEdit = z.infer<
  typeof companyUserProfileEditSchema
>;
export type ChangePassword = z.infer<typeof changePasswordSchema>;
export type CompanyMemberResetPassword = z.infer<
  typeof companyMemberResetPasswordSchema
>;
